import { ContributorGroupType } from '@/features/contributorGroups/constants'
import { ContributorStatus, OfferQuotationStatus, OfferStage, OfferStatus, RoleInOffer } from '..'
import { getStage } from '../../helpers'

export const offerQuotationGroupPolicyType = {
  QUOTATION_OFFER_OVERVIEW: 'QUOTATION_OFFER_OVERVIEW',
  QUOTATION_OFFER_OVERVIEW_SALES_SIDE: 'QUOTATION_OFFER_OVERVIEW_SALES_SIDE',
  QUOTATION_SUB_SYSTEM: 'QUOTATION_SUB_SYSTEM',
  QUOTATION_COMMERCIAL_CHECKLIST: 'QUOTATION_COMMERCIAL_CHECKLIST',
  QUOTATION_LEGAL: 'QUOTATION_LEGAL',
  QUOTATION_DOCUMENT: 'QUOTATION_DOCUMENT',
  QUOTATION_DOCUMENT_CONFIRM_DAMEX: 'QUOTATION_DOCUMENT_CONFIRM_DAMEX',
  QUOTATION_DOCUMENT_TENDER_QUERY: 'QUOTATION_DOCUMENT_TENDER_QUERY',
  QUOTATION_DOCUMENTS_SIGNED_COMMERCIAL_PROPOSAL: 'QUOTATION_DOCUMENTS_SIGNED_COMMERCIAL_PROPOSAL',
  QUOTATION_DOCUMENTS_LEGAL: 'QUOTATION_DOCUMENTS_LEGAL',
  QUOTATION_LEGAL_CONCLUSION: 'QUOTATION_LEGAL_CONCLUSION',
  QUOTATION_APPROVAL: 'QUOTATION_APPROVAL',
  QUOTATION_APPROVAL_REMOVE_CONTRIBUTOR: 'QUOTATION_APPROVAL_REMOVE_CONTRIBUTOR',
  QUOTATION_ADD_CONTRIBUTOR: 'QUOTATION_ADD_CONTRIBUTOR',
  QUOTATION_APPROVAL_EMAIL_APPROVER: 'QUOTATION_APPROVAL_EMAIL_APPROVER',
}

const isSalesSide = (role) => {
  return [RoleInOffer.CREATOR, RoleInOffer.INITIATOR, RoleInOffer.DEPT_USER].includes(role)
}
const isContributor = (role) => {
  return [
    RoleInOffer.COMMERCIAL_PROJECT_MANAGER,
    RoleInOffer.TECHNICAL_PROJECT_MANAGER,
    RoleInOffer.CONTRIBUTOR_LEGAL,
    RoleInOffer.CONTRIBUTOR_QS,
    RoleInOffer.CONTRIBUTOR_OTHER,
  ].includes(role)
}

const canEdit = ({ role, isFreeze = false, offerStatus, roleDetail = {} }) =>
  !isFreeze &&
  (isSalesSide(role) || (isContributor(role) && ![ContributorStatus.REVIEWED].includes(roleDetail))) &&
  [OfferStatus.QUOTATION_DRAFT, OfferStatus.QUOTATION_REJECTED, OfferStatus.QUOTATION_SUBMITTED].includes(offerStatus)

export const offerQuotationGroupPolicies = {
  [offerQuotationGroupPolicyType.QUOTATION_OFFER_OVERVIEW]: {
    view: true,
    edit: canEdit,
  },
  [offerQuotationGroupPolicyType.QUOTATION_OFFER_OVERVIEW_SALES_SIDE]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) =>
      !isFreeze &&
      isSalesSide(role) &&
      [OfferStatus.QUOTATION_DRAFT, OfferStatus.QUOTATION_REJECTED, OfferStatus.QUOTATION_SUBMITTED].includes(
        offerStatus
      ),
  },
  [offerQuotationGroupPolicyType.QUOTATION_SUB_SYSTEM]: {
    view: true,
    edit: canEdit,
  },
  [offerQuotationGroupPolicyType.QUOTATION_COMMERCIAL_CHECKLIST]: {
    view: true,
    edit: canEdit,
  },
  [offerQuotationGroupPolicyType.QUOTATION_LEGAL]: {
    view: true,
    edit: canEdit,
  },

  [offerQuotationGroupPolicyType.QUOTATION_DOCUMENT]: {
    view: true,
    edit: canEdit,
  },
  [offerQuotationGroupPolicyType.QUOTATION_DOCUMENT_CONFIRM_DAMEX]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) => !isFreeze && role === RoleInOffer.INITIATOR,
  },
  [offerQuotationGroupPolicyType.QUOTATION_DOCUMENT_TENDER_QUERY]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) =>
      !isFreeze && [RoleInOffer.INITIATOR, RoleInOffer.CREATOR].includes(role),
  },
  [offerQuotationGroupPolicyType.QUOTATION_DOCUMENTS_SIGNED_COMMERCIAL_PROPOSAL]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) =>
      isSalesSide(role) && offerStatus === OfferQuotationStatus.QUOTATION_APPROVED,
  },
  [offerQuotationGroupPolicyType.QUOTATION_LEGAL_CONCLUSION]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) =>
      !isFreeze &&
      role === RoleInOffer.CONTRIBUTOR_LEGAL &&
      [OfferStatus.QUOTATION_DRAFT, OfferStatus.QUOTATION_REJECTED, OfferStatus.QUOTATION_SUBMITTED].includes(
        offerStatus
      ),
  },
  [offerQuotationGroupPolicyType.QUOTATION_DOCUMENTS_LEGAL]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) => {
      return (
        !isFreeze &&
        (isSalesSide(role) || role === RoleInOffer.CONTRIBUTOR_LEGAL) &&
        [OfferStatus.QUOTATION_DRAFT, OfferStatus.QUOTATION_REJECTED, OfferStatus.QUOTATION_SUBMITTED].includes(
          offerStatus
        )
      )
    },
  },
  [offerQuotationGroupPolicyType.QUOTATION_APPROVAL]: {
    view: true,
    edit: canEdit,
  },

  [offerQuotationGroupPolicyType.QUOTATION_APPROVAL_EMAIL_APPROVER]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) => isSalesSide(role),
  },
  [offerQuotationGroupPolicyType.QUOTATION_ADD_CONTRIBUTOR]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) => {
      return canEdit({ role, isFreeze, offerStatus, roleDetail }) && offerStatus !== OfferStatus.QUOTATION_REJECTED
    },
  },
  [offerQuotationGroupPolicyType.QUOTATION_APPROVAL_REMOVE_CONTRIBUTOR]: {
    view: true,
    edit: ({ role, isFreeze = false, offerStatus, roleDetail = {} }) => {
      return (
        !isFreeze &&
        isSalesSide(role) &&
        [OfferStatus.QUOTATION_DRAFT, OfferStatus.QUOTATION_REJECTED].includes(offerStatus)
      )
    },
  },
}
